
import { add } from './position';


export default (function (droppable, point) {
  var closestScrollable = droppable.viewport.closestScrollable;
  if (!closestScrollable) {
    return point;
  }

  return add(point, closestScrollable.scroll.diff.value);
});


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/state/with-droppable-scroll.js
// module id = 757
// module chunks = 1